import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import "./Homework.css";
import SecBTN from '../../UI/SecBTN';
import classes from "../PaperFormat/PaperFormat.module.css";

import { linkReplaceFn } from '../../utils/custom_funtions';
import axios from 'axios';
import { Navigate, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';




const QuestionsCard = ({ questionsData, module_type, questionRange,uncheckRange,savedData }) => {
  const [allChecked, setAllChecked] = useState(false);
  const [checkedQuestions, setCheckedQuestions] = useState(new Array(questionsData?.length).fill(false));
  const [loading,setLoading]=useState(true);
  const navigate=useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const questionsPerPage = 5; // Number of questions per page

  // Calculate the total number of pages
  const totalPages = Math.ceil(questionsData?.length / questionsPerPage);

  // Calculate the current questions to display
  const currentQuestions = questionsData &&  questionsData?.slice(
    (currentPage - 1) * questionsPerPage,
    currentPage * questionsPerPage
  );

  useEffect(() => {
    setAllChecked(false);
    setCheckedQuestions(new Array(questionsData?.length).fill(false));
  }, [questionsData, module_type]);

  useEffect(() => {
    if (!questionRange) return;

    const range = questionRange.split('-').map(Number);
    if (range.length === 2) {
      const [start, end] = range;
      const updatedCheckedQuestions = [...checkedQuestions];

      for (let i = start - 1; i < end; i++) {
        if (i >= 0 && i < updatedCheckedQuestions.length) {
          updatedCheckedQuestions[i] = true;
        }
      }

      setCheckedQuestions(updatedCheckedQuestions);
      setAllChecked(updatedCheckedQuestions.every(Boolean));
    }

    // for unchecked data updated list
   
   

  }, [questionRange]);


  useEffect(() => {
    
    // for unchecked data updated list
    if(uncheckRange.length===2){
     const first=uncheckRange[0];
     const last=uncheckRange[1];
     const updatedCheckedQuestions = [...checkedQuestions];
     for (let i = first - 1; i < last; i++) {
      if (i >= 0 && i < updatedCheckedQuestions.length) {
        updatedCheckedQuestions[i] = false;
      }
    }
    setCheckedQuestions(updatedCheckedQuestions);
    uncheckRange=[];
  }
   

  }, [uncheckRange]);

  const handleMainCheckboxChange = () => {
    const newCheckedState = !allChecked;
    setAllChecked(newCheckedState);
    setCheckedQuestions(new Array(questionsData?.length).fill(newCheckedState));
  };

  const handleCheckboxChange = (index) => {
    const updatedCheckedQuestions = [...checkedQuestions];
    updatedCheckedQuestions[index] = !updatedCheckedQuestions[index];
    setCheckedQuestions(updatedCheckedQuestions);
    const areAllChecked = updatedCheckedQuestions.every(Boolean);
    setAllChecked(areAllChecked);
  };

  // Helper function to handle page change
  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Function to generate page numbers with ellipsis for large number of pages
  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPagesToShow = 5; // Show a max of 5 page numbers at a time

    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, currentPage + 2);

    if (currentPage <= 3) {
      startPage = 1;
      endPage = Math.min(5, totalPages);
    } else if (currentPage >= totalPages - 2) {
      startPage = Math.max(1, totalPages - 4);
      endPage = totalPages;
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          className={`pagination-button ${i === currentPage ? 'active' : ''}`}
          onClick={() => handlePageClick(i)}
        >
          {i}
        </button>
      );
    }

    if (startPage > 1) {
      pageNumbers.unshift(<span key="start-ellipsis">...</span>);
      pageNumbers.unshift(
        <button key={1} className="pagination-button" onClick={() => handlePageClick(1)}>1</button>
      );
    }

    if (endPage < totalPages) {
      pageNumbers.push(<span key="end-ellipsis">...</span>);
      pageNumbers.push(
        <button key={totalPages} className="pagination-button" onClick={() => handlePageClick(totalPages)}>{totalPages}</button>
      );
    }

    return pageNumbers;
  };


  const handleSave = async () => {
    try {
      // Get the checked questions
      const selectedQuestions = questionsData?.filter((_, index) => checkedQuestions[index]);
  
      let selectedQids=[];


      const qidRange =Array( savedData.rangelist
      .map(range => `${range[0]}-${range[1]}`) // Convert [first, last] into "first-last"
      .join(','));
      
       
        
        const m_id=selectedQuestions[0]?.module_id;
    
      if(module_type==="DPP"){
        selectedQids=selectedQuestions.map(question=>question.excersie_type);
      }
      else if(module_type==="CPS"){
        selectedQids=selectedQuestions.map(question=>question.paper_id);
      }
      else{
        selectedQids = selectedQuestions.map(question => question.qid);

      }
      console.log(selectedQids);
      // Prepare the payload for the API
      const payload = {
        module_id: m_id,
        topic_id: savedData.topicId,
        faculty_id: savedData.facultyId,
        batch: savedData.batch,
        sub_topic_id: savedData.subtoicId,
        subject_id: savedData.subjectId,
        qid_range: qidRange,
        qids: selectedQids
      };
  
      // Post the data using axios
      const response = await axios.post('https://learning.motion.ac.in/motioneducation/api/v1/homework_questions_save', payload);
  
      // Handle success response
      if(response.data.status===200){
      toast.success("Questions saved Sucessfully");
      console.log('Data saved successfully:', response.data);
      window.location.reload();
      }
      else{
        toast.error("Please Select Questions");
      }
    } catch (error) {
      // Handle error response
      console.error('Error saving data:', error);
      
    }
  };

  const HandlePreview=()=>{
    
    // const selectedQuestions = questionsData?.filter((_, index) => checkedQuestions[index]);
    // const ModuleId=selectedQuestions[0]?.module_id;
    // const preview_data={
    //     module_id:ModuleId,
    //     topic_id: savedData.topicId,
    //     faculty_id: savedData.facultyId,
    //     batch: savedData.batch,
    //     sub_topic_id: savedData.subtoicId,
    //     subject_id: savedData.subjectId
    // }
    
    // navigate("./preview",{state:{preview_data:preview_data}});
  }

  return (
    <div className='questions-container'>
      <Card className="questions-card">
        <div className='selectall'>
        <button  onClick={handleMainCheckboxChange}>Select all</button>
        </div>
        {currentQuestions?.map((question, index) => (
          <div key={question.qid} className="question-item">
            <div className="question-header">
              {question.already_saved==0 &&
              <input
                type="checkbox"
                className="question-checkbox"
                checked={checkedQuestions[index + (currentPage - 1) * questionsPerPage]}
                onChange={() => handleCheckboxChange(index + (currentPage - 1) * questionsPerPage)}
              
              />}
              <label className="question-number">
                {module_type === "DPP"
                  ? question.excersie_type
                  : module_type === "CPS"
                    ? question.sub_topic_name
                    : `Question ${index + 1 + (currentPage - 1) * questionsPerPage}`}
              </label>
              {question.already_saved===1 &&
              <p className='saved-question'>Already Saved on: {question.saved_date}</p>
              }
            </div>
            <div className="question-text">
              {module_type === "DPP" || module_type === "CPS"
                ? `Total Questions: ${question.questions_list?.length || 0}`
                : <p dangerouslySetInnerHTML={{ __html: linkReplaceFn(question.q_text)
                }} />}
            </div>
          </div>
        ))}
      </Card>

      {/* <div className="pagination-buttons">
        {renderPageNumbers()}
      </div> */}

      <div className='action-btns'>
      <SecBTN className={`${classes.activate} sec-btn`} onClick={()=> window.scrollTo({ top: 0, behavior: 'smooth' })}>Preview</SecBTN>
        
        <div className="pagination-buttons">
        {renderPageNumbers()}
      </div>
      <SecBTN  className={classes.activate} onClick={handleSave}>Save </SecBTN>
      </div>
    </div>
  );
};

export default QuestionsCard;
